import {
  PibisiAlert as PibisiAlertPrimitive,
  PibisiMatch as PibisiMatchPrimitive
} from 'api/generated';

export enum LegalTypes {
  BUSINESS = 'Company',
  INDIVIDUAL = 'Individual'
}

export type PibisiAlert = PibisiAlertPrimitive & {
  legalType: LegalTypes;
  legalName: string;
  customerId: string;
};

export type PibisiMatch = PibisiMatchPrimitive & {
  legalType: LegalTypes;
  legalName: string;
  customerId: string;
};
